export const INICIO_BIENVENIDA={id:0,ruta:"/bienvenida"};

export const ARREGLO_RUTAS=[INICIO_BIENVENIDA];

export const deslizarDerecha=(rutaDesde, rutaHasta)=>{

    if (rutaDesde==="/" || rutaHasta==="/") return true;

    else {

    let desde=ARREGLO_RUTAS.filter((ruta)=>ruta.ruta===rutaDesde)[0];
    let hasta=ARREGLO_RUTAS.filter((ruta)=>ruta.ruta===rutaHasta)[0];
    
    return (desde===undefined || hasta===undefined?true:(hasta.id>desde.id?true:false));

    }
}
